import { createFileRoute } from '@tanstack/react-router';

export type CallIntelSearch = {
  filters?: string;
  ['submit-feedback']?: boolean;
  subViewType?: string;
  subViewId?: string;
  tab?: string;
  mailer?: string;
  metric?: string;
};

/**
 * Route definition for wrapper library
 */
export const Route = createFileRoute('/analytics/call-intelligence')({
  staticData: { team: 'analytics' },
  validateSearch: (search: CallIntelSearch): CallIntelSearch => {
    return {
      filters: search.filters,
      ['submit-feedback']: search['submit-feedback'],
      subViewType: search.subViewType,
      subViewId: search.subViewId,
      tab: search.tab,
      mailer: search.mailer,
      metric: search.metric,
    };
  },
});
